import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import pathConfiguration from 'src/configuration/path'
import LPContainer from '~/components/LandingPage/LPContainer'
import { ICONS_SOCIAL } from '~/core/constants/social'
import {
  ABOUT_US_URL,
  ATTRACT_SOURCE_URL,
  FEATURES_URL,
  HIRE_ANALYTICS_URL,
  SOLUTIONS_ENTERPRISE_URL,
  SOLUTIONS_RECRUITMENT_AGENCY_URL,
  SOLUTIONS_URL,
  TALENT_AI_URL,
  TALENT_INTELLIGENCE_URL,
  TRACK_COLLABORATE_URL,
  URL_BLOG,
  URL_LOGIN_APP
} from '~/core/constants/url'
import { Button } from '~/core/ui/Button'
import { TextButton } from '~/core/ui/TextButton'
import { cn } from '~/core/ui/utils'
import MobileNavigation from './MobileNavigation'
import NavigationBar, { NavItemsProps } from './NavigationBar'

const navContent: NavItemsProps = [
  {
    label: 'footer:solutions',
    href: SOLUTIONS_URL,
    target: '_self',
    subItems: [
      {
        label: 'footer:for_enterprises',
        subLabel: 'nav:for_enterprises',
        href: SOLUTIONS_ENTERPRISE_URL
      },
      {
        label: 'footer:for_recruitment_agency',
        subLabel: 'nav:for_recruitment_agency',
        href: SOLUTIONS_RECRUITMENT_AGENCY_URL
      }
    ]
  },
  {
    label: 'footer:product',
    href: ATTRACT_SOURCE_URL,
    target: '_self',
    subItems: [
      {
        label: 'footer:talent_platform',
        subLabel: 'nav:talent_platform',
        href: TALENT_INTELLIGENCE_URL
      },
      {
        label: 'footer:talent_ai',
        subLabel: 'nav:talent_ai',
        href: TALENT_AI_URL,
        isSub: true
      },
      {
        label: 'footer:ats',
        subLabel: 'nav:ats',
        href: FEATURES_URL
      },
      {
        label: 'footer:attract_source',
        subLabel: 'nav:find_best_talents',
        href: ATTRACT_SOURCE_URL,
        isSub: true,
        isSubNotLast: true
      },
      {
        label: 'footer:track_collaboration',
        subLabel: 'nav:work_with_your_team',
        href: TRACK_COLLABORATE_URL,
        isSub: true,
        isSubNotLast: true
      },
      {
        label: 'footer:hire_analytics',
        subLabel: 'nav:data_driven_hiring',
        href: HIRE_ANALYTICS_URL,
        isSub: true
      }
    ]
  },
  {
    label: 'footer:resources',
    href: '#',
    subItems: [
      { label: 'footer:blog', href: URL_BLOG }
      // {
      //   label: 'footer:hr-okr-ebook',
      //   href: HR_OKR_EBOOK_URL,
      //   icon: 'book_nav'
      // },

      // {
      //   label: 'footer:help_center',
      //   href: URL_HELP_CENTER,
      //   icon: 'help_nav'
      // }
    ]
  },
  {
    label: 'footer:about_us',
    href: ABOUT_US_URL,
    target: '_self'
  }
]

const HeaderLandingPage: FC<{
  isHidRequestDemoButton?: boolean
  customContainerHeader?: string
  animationOffset?: number
}> = ({
  isHidRequestDemoButton = true,
  customContainerHeader,
  animationOffset
}) => {
  const { t, i18n } = useTranslation()
  // const { scrollY } = useScrollPosition()
  const isHavingAnimation = !!animationOffset

  return (
    <div
      className={cn(
        'z-[90] border-b sticky top-0 bg-white',
        // when having animation, on first visit, without scrolling, bg is transparent
        // bg will turn to blue when start scrolling
        // bg will turn to white when scroll to the offset (over the hero section)
        {
          'tablet:fixed tablet:inset-x-0 border-b': isHavingAnimation
        },
        customContainerHeader
      )}>
      <LPContainer>
        <div className={`flex justify-between items-center py-5 tablet:py-4`}>
          <div className="flex items-center flex-1">
            <Link href={pathConfiguration?.default}>
              <Image
                src={ICONS_SOCIAL?.talentsforce_text}
                height={0}
                width={169}
                alt="talentsforce-logo"
                quality={100}
                style={{ maxWidth: 169 }}
              />
            </Link>

            {/* Desktop Navigation */}
            <NavigationBar content={navContent} />
          </div>

          {/* Desktop actions group Navigation */}
          <div className="hidden items-center gap-6 tablet:flex">
            <TextButton
              type="secondary"
              underline={false}
              size="lg"
              label={`${t('lp:log_in')}`}
              onClick={() => window.open(URL_LOGIN_APP, '_blank')}
            />

            {isHidRequestDemoButton && (
              <Link
                href={pathConfiguration.contactRequest}
                locale={i18n?.language}>
                <Button size="lg" label={`${t('lp:request_demo')}`} />
              </Link>
            )}
          </div>

          <div className="tablet:hidden mr-4">
            {isHidRequestDemoButton && (
              <Link
                href={pathConfiguration.contactRequest}
                locale={i18n?.language}>
                <Button size="lg" label={`${t('lp:request_demo')}`} />
              </Link>
            )}
          </div>

          {/* Mobile Navigation Icon */}
          <MobileNavigation navList={navContent} />
        </div>
      </LPContainer>
    </div>
  )
}

export default HeaderLandingPage
